import { Box, Grid, Typography } from "@mui/material";

import { formatDate } from "@aclymatepackages/formatters";

import FeatureErrorBoundary from "../../atoms/FeatureErrorBoundary";

import { useSubscriptionProducts } from "../../../helpers/components/settings";
import { useSubscriptionType } from "../../../helpers/hooks/companyData";

const subscriptionStatusLabels = {
  active: "Active",
  trialing: "Trial",
  canceled: "Canceled",
  expired: "Expired",
  incomplete: "Incomplete"
};

const ProductsDisplay = () => {
  const [subscriptionObj, subscriptionLoading] = useSubscriptionType("saas");
  const [subscriptionProducts, subscriptionProductsLoading] =
    useSubscriptionProducts();

  if (subscriptionLoading || subscriptionProductsLoading) {
    return null;
  }

  const { type: subscriptionType, status, interval, endDate } =
    subscriptionObj;
  const { title } =
    subscriptionProducts.find(
      ({ product }) => product === subscriptionType
    ) || {};

  return (
    <Box p={4}>
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <Typography variant="h4">{title || "No Active Plan"}</Typography>
        </Grid>
        {status && (
          <Grid item>
            <Typography variant="body1" color="textSecondary">
              {`Status: ${subscriptionStatusLabels[status] || status}${
                interval ? ` · Billed ${interval}ly` : ""
              }`}
            </Typography>
          </Grid>
        )}
        {status === "canceled" && endDate && (
          <Grid item>
            <Typography variant="body2" color="textSecondary">
              {`Access ends ${formatDate(endDate)}`}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

const Products = () => (
  <FeatureErrorBoundary featureName="Products">
    <ProductsDisplay />
  </FeatureErrorBoundary>
);
export default Products;
